var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.397c0-6.627 5.373-12 12-12s12 5.373 12 12c0 6.628-5.373 12-12 12s-12-5.372-12-12z",
    fill: "#EBEBEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 9.73a2.167 2.167 0 11-4.334 0 2.167 2.167 0 014.334 0zM8.565 17.23h6.87c.761 0 1.348-.654.992-1.327-.523-.99-1.715-2.172-4.427-2.172-2.712 0-3.904 1.182-4.427 2.172-.356.673.23 1.328.992 1.328z",
    fill: "#D1D1DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.182 10.53a.5.5 0 01.95 0l1.097 3.373h3.547a.5.5 0 01.294.904l-2.576 1.871a.5.5 0 00-.181.56l.983 3.027a.5.5 0 01-.77.56l-2.575-1.872a.5.5 0 00-.588 0l-2.575 1.871a.5.5 0 01-.77-.559l.984-3.028a.5.5 0 00-.181-.559l-2.576-1.87a.5.5 0 01.294-.905h3.183a.5.5 0 00.476-.346l.984-3.028z",
    fill: "#F59E0B"
  })));
}
export default __webpack_public_path__ + "static/media/ratings.48c555ab.svg";
export { SvgRatings as ReactComponent };